// extracted by mini-css-extract-plugin
module.exports = {"container":"_2XJjm","error":"_3VQrW","center":"_1VAf8","content":"_3ZI8l","close":"_2HID8","mobile":"_2sEKJ","hidden":"_2tejC"};